export default {
  GET_DEALERS: (state, payload) => {
    state.dealers = payload
  },
  GET_CURRENT_DEALERS: (state, payload) => {
    state.current_dealers = payload
  }
}
